import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { AddPolicyDataService } from './../../../../_services/signup-process-service/add-policy-data.service';
import { Router , RouterModule } from '@angular/router';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { Capacitor } from '@capacitor/core';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule],
  selector: 'app-x-attempts',
  templateUrl: './x-attempts.component.html',
  styleUrls: ['./x-attempts.component.scss'],
})
export class XAttemptsComponent implements OnInit {
  userData: any;
  policyHolderName: string;
  policyNumber: string;
  noOfAttempts = 0;
  dateOfBirth: any;
  zipCode: string;
  isAcmic = false;
  showMessageApp = false;

  constructor(
    private addPolicyDataService: AddPolicyDataService,
    private acmicService: AcmicService,
    private router: Router
  ) {}
  getObservableData(userData): void {
    this.policyHolderName = `${userData.userDetails.firstName} ${userData.userDetails.middleName} ${userData.userDetails.lastName}`;
    this.policyNumber = `${userData.policyDetail.policynumber.policyNumber}`;
    this.dateOfBirth = `${userData.userDetails.dateOfBirth}`;
    this.zipCode = `${userData.userDetails.zipCode}`;
  }
  ngOnInit(): void {
    this.isAcmic = this.acmicService.isACMIC();
    this.addPolicyDataService.$newPolicy.subscribe((userData) => {
      this.userData = userData;
    });

    if (Capacitor.isNativePlatform()) {
      this.showMessageApp = true;
    }

    this.getObservableData(this.userData);
    this.isAcmic = this.acmicService.isACMIC();
  }
}
